import axios from '../axios'

/*
 * 字典管理模块
 */

// 保存
export const save = (data) => {
  return axios({
    url: '/mDictionary/save',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}
// 删除
export const batchDelete = (data) => {
  return axios({
    url: '/mDictionary/delete',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}
// 分页查询
export const list = (data) => {
  return axios({
    url: '/mDictionary/list',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}
export const dictDetailList = (data) => {
  return axios({
    url: '/mDictionary/dictDetailList',
    method: 'post',
    data
  })
}

export const saveDictDetail = (data) => {
  return axios({
    url: '/sysDictDetail/save',
    method: 'post',
    data
  })
}
export const dictDetailDelete = (data) => {
  return axios({
    url: '/sysDictDetail/delete',
    method: 'post',
    data
  })
}
export const dictDetailEdit = (data) => {
  return axios({
    url: '/sysDictDetail/edit',
    method: 'post',
    data
  })
}
// 根据字典编码获取字典数据
export const getDictionaryByCondition = (groupTitle) => {
  return axios({
    url: '/mDictionary/getDictionaryByCondition',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true, //不序列化参数
    data: {"groupTitle": groupTitle}
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/dictionary.js